module.exports = __webpack_public_path__ + "static/media/login image.492e6497.png";